import React from "react";
import styled from "styled-components";
import FilterTag from "./library/FilterTag";
import { useSearchFiltersContext } from "./library/SearchFilter";
import { mediaMaxWidth } from "../theme/mediaQueriesTemplates";
import { FilterData } from "./pages/recruiter/jobs";

const JobSearchSelectedFilters = (props: Props) => {
  const { filters, sectorLabelMap, currencyLabelMap } = props;

  const statusTags = filters.status.map((item) => ({
    label: item.replace("_", " "),
    value: item,
  }));

  const typeTags = filters.type.map((type) => ({
    label: type.replace("_", " "),
    value: type,
  }));

  const currencyTags = filters.currency.map((id) => ({
    label: currencyLabelMap[id],
    value: id,
  }));

  const sectorTags = filters.sector.map((id) => ({
    label: sectorLabelMap[id],
    value: id,
  }));

  return (
    <SelectedFiltersWrapper id="job-filter-tags">
      <FilterTagGroup tags={statusTags} filter="status" />
      <FilterTagGroup tags={typeTags} filter="type" />
      <FilterTagGroup tags={sectorTags} filter="sector" />
      <FilterTagGroup tags={currencyTags} filter="currency" />
    </SelectedFiltersWrapper>
  );
};

type Tag = {
  label: string;
  value: string | string[];
};

const FilterTagGroup = (props: { filter: string; tags: Tag[] }) => {
  const { tags, filter } = props;
  const { remove } = useSearchFiltersContext();

  if (tags.length === 0) {
    return null;
  }

  return (
    <>
      {tags.map(({ label, value }) => (
        <FilterTag
          key={`${label}-${JSON.stringify(value)}`}
          onClick={() => remove(filter, value)}
        >
          {label}
        </FilterTag>
      ))}
    </>
  );
};

const SelectedFiltersWrapper = styled.div`
  margin-bottom: 0.5rem;
  margin-left: -0.25rem;
  margin-right: -0.25rem;

  ${mediaMaxWidth.smallTablet} {
    display: none;
  }
`;

type Props = {
  filters: FilterData;
  currencyLabelMap: Record<string, string>;
  sectorLabelMap: Record<string, string>;
};

export default JobSearchSelectedFilters;
